<template>
	<div>
		<div class="row g-2 justify-content-end mb-3">
			<div class="col-auto">
				<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah data</el-button>
			</div>
			<div class="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4">
				<el-input v-model="searchKey" placeholder="Cari . . ." prefix-icon="Search" clearable />
			</div>
		</div>
		<el-form :model="formEdit" @submit.prevent="updateUserPresensi" ref="formEdit">
			<el-table :data="userPresensi" row-key="non_gtk_id" table-layout="auto" v-loading="loading">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." :index="indexMethod" />
				<el-table-column label="Nama" prop="nama" />
				<el-table-column label="ID Presensi" prop="user_presensi_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="new_user_presensi_id" v-if="rowEditing === row" class="mb-0">
								<el-input type="text" v-model="formEdit.new_user_presensi_id" :placeholder="row.user_presensi_id" clearable style="min-width: 100px" />
							</el-form-item>
							<span v-else :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Status" prop="aktif">
					<template #default="{ row }">
						{{ row.aktif ? "Aktif" : "Tidak aktif" }}
					</template>
				</el-table-column>
				<el-table-column label="Kontak" prop="kontak" />
				<el-table-column label="Tindakan">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-space :spacer="spacer" :size="2" v-if="rowEditing === row">
								<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
								<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
							</el-space>
							<el-space :spacer="spacer" :size="2" v-else>
								<el-tooltip content="Edit data">
									<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
								</el-tooltip>
								<el-tooltip content="Hapus data">
									<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
								</el-tooltip>
							</el-space>
						</transition>
					</template>
				</el-table-column>
			</el-table>
		</el-form>
		<el-pagination
			class="flex-wrap justify-content-center mt-3"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="[5, 10, 25, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalData"
			@change="getUserPresensi" />

		<el-form :model="formCreate" :rules="rulesCreate" ref="formCreate" @submit.prevent="insertUserPresensi" label-width="auto" :disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" title="Tambah Data" align-center :width="modalWidth">
				<el-form-item prop="user_presensi_id" label="ID Presensi">
					<el-input v-model="formCreate.user_presensi_id" placeholder="Masukkan PIN/ID Presensi" />
				</el-form-item>
				<el-form-item prop="type_id" label="Non-GTK">
					<el-select v-model="formCreate.type_id" filterable placeholder="Pilih Non-GTK">
						<el-option v-for="nu in listNonUser" :key="nu.non_gtk_id" :label="nu.nama" :value="nu.non_gtk_id" />
					</el-select>
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "UserNonGtk",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			userPresensi: [],
			listNonUser: [],
			dialogCreateVisible: false,
			formCreate: {
				user_presensi_id: null,
				type_id: null,
			},
			rulesCreate: {
				user_presensi_id: [{ required: true, message: "Masukkan PIN/ID presensi", trigger: "change" }],
				type_id: [{ required: true, message: "Pilih non-gtk", trigger: "change" }],
			},
			rowEditing: null,
			formEdit: {
				new_user_presensi_id: null,
			},
			inserting: false,
			loading: true,
			updating: false,
			deleting: false,
			searchKey: null,
			debounceSearch: null,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		updateEditing: Function,
		modalWidth: String,
	},
	computed: {
		formEditChanged() {
			return this.rowEditing !== null && this.formEdit.new_user_presensi_id !== null;
		},
	},
	watch: {
		searchKey() {
			clearTimeout(this.debounceSearch);
			this.loading = true;

			this.debounceSearch = setTimeout(() => {
				if (this.currentPage === 1) this.getUserPresensi();
				else this.currentPage = 1;
			}, 500);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		rowEditing() {
			this.$refs.formEdit.resetFields();
			this.formEdit = {
				new_user_presensi_id: null,
			};
		},
		formEditChanged(val) {
			this.updateEditing(val);
		},
	},
	mounted() {
		this.$ws.main.on("user:inserted", this.insertedUser);
		this.$ws.main.on("user:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getUserPresensi();
		this.getListNonUser();
	},
	beforeUnmount() {
		this.$ws.main.off("user:inserted");
		this.$ws.main.off("user:updated");
		this.$ws.main.off("user:deleted");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formEditChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedUser(data) {
			if (data.type !== "non_gtk") return;

			if (this.formCreate.type_id === data.non_gtk_id) this.formCreate.type_id = null;

			const oldNonUserIndex = this.listNonUser.findIndex((u) => u.non_gtk_id === data.non_gtk_id);

			if (oldNonUserIndex !== -1) this.listNonUser.splice(oldNonUserIndex, 1);

			if (!this.searchKey || (this.searchKey && (data.user_presensi_id.includes(this.searchKey) || data.nama.toLowerCase().includes(this.searchKey.toLowerCase())))) {
				const temp = [...this.userPresensi];

				temp.push(data);

				temp.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});

				const checkIndex = temp.findIndex((t) => t.non_gtk_id === data.non_gtk_id);
				if (checkIndex === this.pageSize) {
					this.totalData++;
					return;
				}

				if (checkIndex === 0) {
					this.getUserPresensi();
					return;
				}

				this.userPresensi.splice(checkIndex, 0, data);
				if (this.userPresensi.length > this.pageSize) this.userPresensi.pop();

				this.totalData++;
			}
		},
		updatedUser(data) {
			if (data.type !== "non_gtk") return;

			const index = this.userPresensi.findIndex((up) => up.user_presensi_id === data.old_user_presensi_id);

			if (index === -1) return;

			if (this.rowEditing && this.rowEditing.user_presensi_id === data.old_user_presensi_id) this.rowEditing = null;

			this.userPresensi[index].user_presensi_id = data.user_presensi_id;
		},
		deletedUser(data) {
			if (data.type !== "non_gtk") return;

			this.listNonUser.push({
				non_gtk_id: data.non_gtk_id,
				nama: data.nama,
			});

			const totalPages = Math.ceil(this.totalData / this.pageSize);
			const oldUserIndex = this.userPresensi.findIndex((up) => up.user_presensi_id === data.user_presensi_id);

			if (oldUserIndex !== -1) {
				if (this.rowEditing && this.rowEditing.user_presensi_id === data.old_user_presensi_id) this.rowEditing = null;

				if (this.currentPage === totalPages) {
					this.userPresensi.splice(oldUserIndex, 1);
					this.totalData--;
				} else {
					this.getUserPresensi();
				}
			} else {
				if (this.searchKey === null || (this.searchKey && (data.old_user_presensi_id.includes(this.searchKey) || data.nama.toLowerCase().includes(this.searchKey.toLowerCase())))) {
					const temp = [...this.userPresensi];

					temp.push(data);
					temp.sort((a, b) => {
						return a.nama.localeCompare(b.nama);
					});

					const checkIndex = temp.findIndex((t) => t.non_gtk_id === data.non_gtk_id);
					if (checkIndex === this.pageSize) {
						this.totalData--;
						return;
					}

					if (checkIndex === 0 && this.currentPage === totalPages) {
						this.userPresensi.shift();
						this.totalData--;
						return;
					}

					this.getUserPresensi();
				}
			}
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, ["Anda yakin ingin menghapus pengguna presensi ", h("mark", { class: "fw-bold" }, row.nama), "?"]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteUserPresensi(row))
				.catch(() => {});
		},
		async getUserPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.get("/user/index/non-gtk", {
					params: {
						search_key: this.searchKey || undefined,
						page: this.currentPage,
						limit: this.pageSize,
					},
				});

				await new Promise((resolve) => setTimeout(resolve, 500));

				this.userPresensi = data.data.user_presensi;
				this.totalData = data.data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getListNonUser() {
			try {
				const { data } = await this.$defaultApi.get("/user/list/non-gtk/non-user");

				this.listNonUser = data.data.list_non_user_presensi;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async insertUserPresensi() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/user", {
					...this.formCreate,
					type: "non_gtk",
				});

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateUserPresensi() {
			this.updating = true;
			try {
				if (!this.formEditChanged) {
					throw Error("Anda belum melakukan perubahan");
				}

				const { data } = await this.$defaultApi.patch(`/user/${this.rowEditing.user_presensi_id}`, {
					user_presensi_id: this.formEdit.new_user_presensi_id,
				});

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteUserPresensi(row) {
			this.deleting = true;
			try {
				const { data } = await this.$defaultApi.delete(`/user/${row.user_presensi_id}`);

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
